import template from './index.html'

import controller from './controller'

config.vsNgType = 'config'
config.vsName = 'partDropDown'

config.$inject = ['formlyConfigProvider']
function config(formlyConfigProvider) {
  let type = {
    name: 'partDropDown',
    templateUrl: template,
    wrapper: ['bootstrapLabel', 'bootstrapHasError'],
    controller: controller
  }
  formlyConfigProvider.setType(type)
}

export default config